import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../core/components/Navbar/Navbar';
import Footer from '../core/components/Footer/Footer';
import CSSLoader from './CSSLoader';
import FloatingActionButton from '../core/components/Common/FloatingActionButton';
import BookingFomoPopup from '../core/components/Common/BookingFomoPopup';
import SalesPopup from '../core/components/Common/SalesPopup';

const CoreLayout = ({ children, userLogout }) => {
  const location = useLocation();

  const hideNavbar = location.pathname.startsWith('/boats/');
  const isLandingPage = location.pathname === '/experience';

  return (
    <div className="core-app" id="core-app">
      <CSSLoader />
      {!hideNavbar && !isLandingPage && <Navbar userLogout={userLogout} />}
      <div className="core">
        {children}
      </div>
      {!isLandingPage && (
        <>
          <BookingFomoPopup />
          <SalesPopup />
          <FloatingActionButton />
          <Footer />
        </>
      )}
    </div>
  );
};

export default CoreLayout;